import React, { useEffect, useContext, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch, useSelector } from 'react-redux';

import { getClassifications, getFeedClassifications } from '../../../services/documentsService';

import { filterBy } from '@progress/kendo-data-query';

import FilterCtx from '../../../../context/filterContext/filterCtx';
import { RootState } from '../../../../redux/store';
import { POPUP } from '../../../../redux/types';

import { IClassification } from '../../../services/types/IClassification';
import { IClassificationsFilter } from '../../types/IClassificationsFilter';

import InfoTooltip from '../../infoTooltip/infoTooltip';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Switch } from '@progress/kendo-react-inputs';

import '../../multiselect/multiselect.scss';
import '../filters.scss';

const ClassificationsFilter: React.FC<IClassificationsFilter> = ({ table, toggleOn }) => {
  const [value, setValue] = useState<IClassification[]>([]);
  const [filterChoice, setFilterChoice] = useState<IClassification[]>([]);
  const [cashChoice, setCashChoice] = useState<IClassification[]>([]);
  const [checked, setChecked] = useState(false);

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const filterCtx: any = useContext(FilterCtx);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  const handleClassificationToggleChange = (e): void => {
    setChecked(e.value);
    filterCtx.setClassificationToggle(e.value);
    filterCtx.setClassifications([]);
    setValue([]);
    let tempArray = filterCtx.slicerChoices;
    let tempGroupsArray = filterCtx.initialGroup;
    if (e.value) {
      filterCtx.setSlicerChoices([...filterCtx.slicerChoices, 'classifications']);
      filterCtx.setInitialGroup([...filterCtx.initialGroup, { field: 'classifications' }]);
    } else {
      tempArray = filterCtx.slicerChoices.filter((item) => item !== 'classifications');
      tempGroupsArray = filterCtx.initialGroup.filter((item) => item.field !== 'classifications');
      filterCtx.setSlicerChoices(tempArray);
      filterCtx.setInitialGroup(tempGroupsArray);
    }
  };

  const handleClassificationChange = (event): void => {
    setValue(event.target.value);
  };

  const handleClassificationFilterChange = (event: any): void => {
    setFilterChoice(filterBy(cashChoice.slice(), event.filter));
  };

  useEffect(() => {
    setChecked(filterCtx.slicerChoices.indexOf('classifications') + 1 > 0);
    if (table === 'documents') {
      getClassifications()
        .then((res: IClassification[]) => {
          setFilterChoice(res);
          setCashChoice(res);
        })
        .catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    } else {
      getFeedClassifications()
        .then((res: IClassification[]) => {
          setFilterChoice(res);
          setCashChoice(res);
        })
        .catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    }

    if (table === 'documents' && filterCtx.classifications) {
      setValue(filterCtx.classifications);
    } else {
      setValue(filterCtx.classificationsActivity);
    }
  }, [impersonation]);

  useEffect(() => {
    if (table === 'documents') {
      filterCtx.setClassifications(value);
    } else {
      filterCtx.setClassificationsActivity(value);
    }
  }, [value]);

  return (
    <div className='classifications-filter-wrapper pointer'>
      {toggleOn && <InfoTooltip />}
      <MultiSelect
        className={toggleOn && checked ? 'multiselect-padding-left custom-dropdown-style filters-dropdown filters-dropdown-with-slicer' : toggleOn && !checked ? 'custom-dropdown-style filters-dropdown filters-dropdown-with-slicer' : 'custom-dropdown-style filters-dropdown'}
        data={filterChoice}
        textField='name'
        dataItemKey='id'
        value={value}
        placeholder={t('FILTERS.CLASSIFICATIONS')}
        filterable={true}
        disabled={toggleOn && checked}
        onChange={handleClassificationChange}
        onFilterChange={handleClassificationFilterChange}
      />
      {toggleOn && checked && filterCtx.slicerChoices.indexOf('classifications') + 1 > 0 && (
        <div className='switch-number-container'>
          <span>{filterCtx.slicerChoices.indexOf('classifications') + 1}</span>
        </div>
      )}
      {toggleOn && (
        <div className='switch-container'>
          <Switch onLabel={''} offLabel={''} checked={checked} onChange={handleClassificationToggleChange} />
        </div>
      )}
    </div>
  );
};

export default ClassificationsFilter;
